import React from "react";
import { Helmet } from "react-helmet";
import OptimizedImage from "./OptimizedImage";

import "../pages/styles/carousel.css";

// Single fixed hero banner (first promotional image).
const hero = {
  src: process.env.PUBLIC_URL + "/5.webp",
  srcSet: `${process.env.PUBLIC_URL}/5.webp 1200w`,
  sizes: "(max-width: 1180px) 100vw, 1180px",
  alt: "HR Course promotional image, showcasing professional development opportunities.",
};

const PartnerCarousel = () => {
  return (
    <section className="hero-banner" aria-label="Talent Track featured program">
      <Helmet>
        <link
          rel="preload"
          as="image"
          href={process.env.PUBLIC_URL + "/5.webp"}
          fetchpriority="high"
          type="image/webp"
        />
      </Helmet>

      <div className="hero-banner-inner">
        <OptimizedImage
          src={hero.src}
          srcSet={hero.srcSet}
          alt={hero.alt}
          className="hero-banner-img"
          priority
          width="1200"
          height="500"
          sizes={hero.sizes}
          decoding="sync"
        />
      </div>
    </section>
  );
};

export default PartnerCarousel;
